import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { User, Permission } from '@/types/user'
import type { Entity } from '@/types/entity'
import { Roles } from '@/types/common'
import { userApi } from '@/api/user'

export const useUserStore = defineStore('user', () => {
  const user = ref<User | null>(null)
  const permissions = ref<Permission[]>([])
  const entities = ref<Entity[]>([])
  const defaultTimeFrameId = ref<number | null>(null)
  const loaded = ref(false)

  const isAdmin = computed(() => user.value?.roleId === Roles.Administrator)
  const isSupervisor = computed(() => user.value?.roleId === Roles.Supervisor)
  const isRegion = computed(() => user.value?.roleId === Roles.Region)
  const userName = computed(() => user.value?.name ?? '')
  const userRole = computed(() => user.value?.role)

  async function fetchUserInfo() {
    const data = await userApi.getInfo()
    user.value = data.user
    permissions.value = data.permissions
    entities.value = data.entities
    defaultTimeFrameId.value = data.defaultTimeFrameId
    loaded.value = true
  }

  function $reset() {
    user.value = null
    permissions.value = []
    entities.value = []
    defaultTimeFrameId.value = null
    loaded.value = false
  }

  return {
    user,
    permissions,
    entities,
    defaultTimeFrameId,
    loaded,
    isAdmin,
    isSupervisor,
    isRegion,
    userName,
    userRole,
    fetchUserInfo,
    $reset,
  }
})
